import { combineReducers } from "redux";

import gallerycategory from "../features/admin/galleryshow/gallerycategory/Slice";

import galleryphoto from "../features/admin/galleryshow/galleryphoto/Slice";

import common from "../features/admin/common/Slice";

const galleryshow = combineReducers({
    gallerycategory,
    galleryphoto,
    common
});

export default galleryshow;